import { List as AntList } from 'antd';
import styled, { css } from 'styled-components';
import { Menu } from 'components/atoms/dropdown';
import { PrivateStyles, withPrivacy } from 'components/atoms/private';
import { PhaseStatusProgress } from './phase-status-progress';

export const CreatePopoverItem = styled(AntList.Item)<{ visible: boolean }>`
  display: flex;
  gap: var(--spacing-04);
  &.ant-list-item {
    visibility: hidden;
    text-align: center;
    justify-content: center;
    ${({ visible }) =>
      visible &&
      css`
        visibility: visible;
      `};
  }
`;

export const List = withPrivacy(
  styled(AntList)<{ forExport: boolean }>`
    flex: 1;
    max-height: ${(props) =>
      props.forExport ? 'fit-content' : 'calc(100vh - 220px)'};
    margin: 0 var(--spacing-03) 0 var(--spacing-04);
    overflow-y: auto;
    padding: var(--spacing-03) var(--spacing-05) var(--spacing-05);
    transition: background-color linear var(--animation-duration-medium);

    .ant-list-item {
      padding: var(--spacing-03) 0;
    }
  `,
  PrivateStyles,
);

export const PhaseStatusProgressBar = styled(PhaseStatusProgress)`
  margin: 0 0.4rem var(--spacing-03) 0.23rem;
`;

export const SwimlaneWrapper = withPrivacy(
  styled.div<{ isClose: boolean }>`
    max-width: ${(props) => (props.isClose ? '0' : '308px')};
    min-width: ${(props) => (props.isClose ? '0' : '308px')};
    width: ${(props) => (props.isClose ? '0' : '308px')};
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    transition: all ${(props) => (props.isClose ? '0.2s' : '0.25s')}
      cubic-bezier(0.4, 0, 0.2, 1);

    &:first-child ${PhaseStatusProgressBar} {
      margin-left: var(--spacing-05);

      > .ant-progress:first-child {
        clip-path: polygon(98% 0, 100% 50%, 98% 98%, 0% 100%, 0% 50%, 0% 0%);
      }
    }

    &:hover {
      ${List} {
        background-color: rgba(237, 238, 240, 0.9);

        ${CreatePopoverItem}.ant-list-item {
          visibility: visible;
        }
      }
    }
  `,
  css`
    :hover {
      ${List} {
        background-color: rgba(255, 249, 213, 0.9);
      }
    }
  `,
);

export const PhaseStatusSummaryContainer = styled.div`
  text-align: center;
  margin: var(--spacing-05) auto;
`;

export const SwimlaneButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  & button:not(:first-child) {
    margin-left: 1px;
  }
  width: 100%;

  .ant-btn.ant-btn-primary.ant-btn-sm:not(.ant-dropdown-trigger) {
    width: 100%;
  }
`;

export const SwimlaneDropdownMenu = styled(Menu)`
  padding: var(--spacing-03) 0;
`;

export const SwimlaneDropdownMenuItem = styled(Menu.Item)`
  display: flex;
  gap: var(--spacing-04);
  height: var(--height-lg);
`;
